export default __webpack_public_path__ + "img/eDdsjRFk.57cf6a7d.svg";